import React, {useState} from "react";
import {Prompt} from "react-router-dom";
import {Button, CircularProgress, Typography} from "@mui/material";
import {ContactForm} from "../forms";
import {nodeService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {verbiage} from "@atttomyx/shared-constants";

const freshData = () => {
    return {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        leadSource: null,
        valid: false,
    }
};

const AddContactPage = (props) => {
    const { snackbar, onSave } = props;
    const [ data, setData ] = useState(freshData());
    const [ saving, setSaving ] = useState(false);

    const resetForm = () => {
        setData(freshData());
    }

    const submitForm = () => {
        setSaving(true);

        const added = {
            firstName: data.firstName,
            lastName: data.lastName,
            emails: [],
            phones: [],
            metadata: {},
        };

        if (data.email) {
            added.emails = [{
                label: "Primary",
                value: data.email,
            }];
        }

        if (data.phone) {
            added.phones = [{
                label: "Primary",
                value: data.phone,
            }];
        }

        if (data.leadSource) {
            added.metadata = {
                leadSource: data.leadSource,
            };
        }

        const success = (contact) => {
            resetForm();
            setSaving(false);

            snackbar.setSuccess("Contact saved");
            onSave(contact);
        };

        const failure = (err) => {
            setSaving(false);

            snackbar.setError(err);
        };

        nodeService.createNode(added, success, failure);
    }

    const valid = data.valid;
    const modified = forms.differ(freshData(), data);

    return saving ?
        <div className="add-contact-page">
            <CircularProgress size="80px"/>
        </div> :
        <div className="add-contact-page">
            <Typography variant="h5" paragraph={true}>
                Add Contact
            </Typography>
            <ContactForm
                snackbar={snackbar}
                data={data}
                onChange={setData}
            />
            <div className="actions">
                <Button color="secondary" variant="text"
                        disabled={!modified}
                        onClick={resetForm}>
                    Undo
                </Button>
                <Button color="primary" size="large"
                        disabled={!valid || !modified}
                        onClick={submitForm}>
                    Save
                </Button>
            </div>
            <Prompt when={modified} message={verbiage.UNSAVED_CHANGES}/>
        </div>
}

export default AddContactPage;
